/**
 * @readonly
 * @constant
 * @enum {number}
 */
export const ExecutionStatuses = {
  /**@default 0 */
  UNPROCESSED: 0,

  /**@default 1 */
  IN_PROGRESS: 1,

  /**@default 2 */
  SUCCEEDED: 2,

  /**@default 4 */
  FAILED: 4,

  /**@default 5 */
  CANELED: 5,

  /**@default 6 */
  NO_ENOUGH_CREDITS: 6,
};
